/* @flow */
import AdminNewCardModal from './AdminNewCardModal';

export default AdminNewCardModal;
